import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="agent" routeLang="en" />;

export const Route = createFileRoute("/en/retail-ai-agent")({
  head: () => publicToolHead("agent", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
